import React, {useState} from "react"
import {Badge} from "reactstrap";
import getImage from "../GetImage";
import {useNavigate} from "react-router-dom";

export default function Product({product})
{
    const [imgIdx, setImgIdx] = useState(0);
    const navigate = useNavigate()
    const hasDiscount = product.calculatedPrice !== product.price
    return(
        <div className="product"
              onClick={() => navigate("/catalog/"+ product.id)}
              onKeyDown={e => { if (e.key === 'Enter') navigate("/catalog/"+ product.id) }}
              role="link"
              tabIndex={0}>
            <div className="product-img-wrap"
                 onMouseEnter={() => setImgIdx(1)}
                 onMouseLeave={() => setImgIdx(0)}>
                <img
                    src={getImage(product.article, product.countImages > 1 ? imgIdx % product.countImages : 0)}
                    alt={product.name}
                    loading="lazy"
                />
            </div>
            <div className="product-badges">
                {(product.new) && <span className="product-badge product-badge-new">new</span>}
                {(product.hot) && <span className="product-badge product-badge-hot">hot</span>}
                {hasDiscount && <span className="product-badge product-badge-discount">-{100 - Math.round(product.calculatedPrice/product.price*100)}%</span>}
            </div>
            <div className="product-info">
                <div className="product-name">{product.name}</div>
                <div className="product-price">
                    {hasDiscount && <span className="product-price-old">{product.price} ₽</span>}
                    <span className="product-price-current">{hasDiscount ? product.calculatedPrice : product.price} ₽</span>
                </div>
            </div>
        </div>)
}
